module.exports = __webpack_public_path__ + "static/media/w2.6a71c190.jpg";